import { render, staticRenderFns } from "./modalAddCostList.vue?vue&type=template&id=478ff43c&scoped=true"
import script from "./modalAddCostList.vue?vue&type=script&lang=js"
export * from "./modalAddCostList.vue?vue&type=script&lang=js"
import style0 from "./modalAddCostList.vue?vue&type=style&index=0&id=478ff43c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478ff43c",
  null
  
)

export default component.exports